<template>
  <QuestionnaireLayout>
    <h2 class="white--text mb-5" v-if="!preparingOption">
      What are you preparing for?
    </h2>
    <div class="mx-auto" style="max-width: 220px" v-if="!preparingOption">
      <v-btn
        x-large
        rounded
        block
        class="font-weight-bold"
        @click="preparingOption = 'G'"
      >
        G
      </v-btn>
      <v-btn
        x-large
        rounded
        block
        class="font-weight-bold mt-3"
        @click="preparingOption = 'G2'"
      >
        G2
      </v-btn>
    </div>
    <div v-else>
      <div v-if="preparingOption === 'G'">
        <p class="white--text">
          Book single driving lessons, and/or road test learning packages
        </p>
        <v-btn
          x-large
          rounded
          class="font-weight-bold"
          to="search?find=instructor"
        >
          Find driving instructor
        </v-btn>
      </div>
      <div v-if="preparingOption === 'G2'">
        <h2 class="white--text mb-5">Choose an option</h2>
        <v-btn
          x-large
          rounded
          class="font-weight-bold"
          to="search?find=package"
        >
          Purchase DriverX BDE curriculum
        </v-btn>
        <p class="white--text mt-2">Get your G2 & Certification early</p>
        <v-btn
          x-large
          rounded
          class="font-weight-bold mt-3"
          to="search?find=instructor"
        >
          Book individual lesson
        </v-btn>
        <p class="white--text mt-2">Find driving instructors near me</p>
      </div>
      <v-btn
        @click="preparingOption = null"
        rounded
        class="mt-3"
        color="primary"
      >
        <v-icon left>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </div>
  </QuestionnaireLayout>
</template>

<script>
import QuestionnaireLayout from '@/components/qauestionnaire/QuestionnaireLayout'

export default {
  data () {
    return {
      preparingOption: null
    }
  },
  components: {
    QuestionnaireLayout
  }
}
</script>
